export const Marquee = ({ items }) => (
  <div
    className="relative overflow-hidden border-y border-gold/15 bg-abyss/40 py-5"
    data-testid="framework-marquee"
    aria-label="ENEXUR proprietary frameworks"
  >
    <div className="flex w-max animate-marquee items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {items.map((it, i) => (
            <span key={i} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-mono text-[11px] uppercase tracking-[0.34em] text-mist">
                {it}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-gold/50" aria-hidden="true" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
